import BlogsRepository from '@/repositories/Blogs/blogsRepository'
import CompanyAboutUsRepository from '@/repositories/Company/companyAboutUsRepository'
import ContactUsRepository from '@/repositories/Company/contactUsRepository'
import DemoRegRepository from '@/repositories/demoRegRepository'
import EducationPageRepository from '@/repositories/Education/educationPageRepository'
import FundingAccountRepository from '@/repositories/fundingAccountRepository'
import GlobalSeoRepository from '@/repositories/globalSeoRepository'
import hantecPolicyRepository from '@/repositories/hantecPolicyRepository'
import HomePageRepository from '@/repositories/Home/homePageRepository'
import InsightProAnalysisRepository from '@/repositories/insightProAnalysis'
import MarketsBlogRepository from '@/repositories/Markets/marketsBlogRepository'
import MarketsPageRepository from '@/repositories/Markets/marketsPageRepository'
import NavigationMenuRepository from '@/repositories/navigationMenuRepository'
import ClientPortalRepository from '@/repositories/Platforms/clientPortalRepository'
import HantecSocialRepository from '@/repositories/Platforms/hantecSocialRepository'
import MetaTrader4Repository from '@/repositories/Platforms/metaTrader4Repository'
import MetaTrader5Repository from '@/repositories/Platforms/metaTrader5Repository'
import MobileTradingAppRepository from '@/repositories/Platforms/mobileTradingAppRepository'
import WebTraderRepository from '@/repositories/Platforms/webTraderRepository'
import PreRegRepository from '@/repositories/preRegRepository'
import PrimeRepository from '@/repositories/PrimeRepository'
import PrivacyPolicyRepository from '@/repositories/privacyPolicyRepository'
import SponsorshipRepository from '@/repositories/sponsorshipRepository'
import TermsAndConditionsRepository from '@/repositories/termsAndConditionsRepository'
import DividendCalendarRepository from '@/repositories/Tools/dividendCalendarRepository'
import EconomicCalendarRepository from '@/repositories/Tools/economicCalendarRepository'
import InsightProSignalsRepository from '@/repositories/Tools/insightProSignalsRepository'
import ToolsPageRepository from '@/repositories/Tools/toolsPageRepository'
import TradingPageRepository from '@/repositories/Trading/tradingPageRepository'
import TradingAccountsRepository from '@/repositories/tradingAccountsRepository'

import BecomePartnerRepository from './Partners/becomePartnerRepository'
import IBPortalRepository from './Partners/ibPortalRepository'
import AcuityOverviewRepository from './Tools/acuityOverview'

const repositories = {
  globalSeoRepository: GlobalSeoRepository,
  navigationMenuRepository: NavigationMenuRepository,
  homePageRepository: HomePageRepository,
  educationPageRepository: EducationPageRepository,
  marketsBlogRepository: MarketsBlogRepository,
  marketsPageRepository: MarketsPageRepository,
  tradingPageRepository: TradingPageRepository,
  blogsRepository: BlogsRepository,
  toolsPageRepository: ToolsPageRepository,
  fundingAccountRepository: FundingAccountRepository,
  hantecPolicyRepository,
  CompanyAboutUsRepository,
  TermsAndConditionsRepository,
  PrivacyPolicyRepository,
  PreRegRepository,
  EconomicCalendarRepository,
  DividendCalendarRepository,
  DemoRegRepository,
  PrimeRepository,
  MobileTradingAppRepository,
  WebTraderRepository,
  HantecSocialRepository,
  MetaTrader4Repository,
  MetaTrader5Repository,
  ClientPortalRepository,
  TradingAccountsRepository,
  ContactUsRepository,
  IBPortalRepository,
  BecomePartnerRepository,
  SponsorshipRepository,
  InsightProAnalysisRepository,
  AcuityOverviewRepository,
  InsightProSignalsRepository
}

type RepositoryType = keyof typeof repositories

export const RepositoryFactory = {
  get: (name: RepositoryType) => repositories[name]
}
